<template>
  <div class="switch-box">
    <div class="current-value auto" @click="showItem">{{defaultOptions.find(item => {return item.value === current}) ? defaultOptions.find(item => {return item.value === current})['name'] : '交'}}</div>
    <div class="switch-content auto" v-if="show">
      <div @click="clickOptions(item)" :class="'switch-item auto ' + (item.value === current ? 'cur' : '')" v-for="(item, index) in defaultOptions" :key="index">{{item.name}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SwitchBox',
  props: [
    'value',
    'options',
    'disableChoose'
  ],
  data () {
    return {
      show: false,
      current: 'must',
      defaultOptions: [
        {
          name: '交',
          value: 'must'
        },
        {
          name: '并',
          value: 'should'
        }
      ]
    }
  },
  watch: {
    'value': function (val) {
      this.current = val || 'must'
    },
    'options': function (val) {
      if (val) {
        this.defaultOptions = val
      }
    }
  },
  methods: {
    clickOptions (item) {
      this.current = item.value
      this.show = false
      this.$emit('input', this.current)
    },
    showItem () {
      if (!this.disableChoose) {
        this.show = !this.show
      }
    }
  },
  mounted () {
    if (this.value) {
      this.current = this.value
    }
    if (this.options) {
      this.defaultOptions = this.options
    }
  },
  created () {
  }
}
</script>

<style scoped>
.switch-box {
  width: 32px;
  height: 32px;
  position: relative;
  border-radius: 32px;
  background: #2d8cf0;
  cursor: pointer;
}
.current-value {
  width: 30px;
  height: 30px;
  border-radius: 30px;
  margin: 1px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.switch-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 32px;
  border-radius: 32px;
  background: #2d8cf0;
  padding-bottom: 1px;
  height: auto;
  overflow: hidden;
}
.switch-content div {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 30px;
  color: #fff;
  margin: 0 auto;
}
.switch-content div:first-child {
  margin-top: 1px;
}
.switch-content div.cur {
  background: #fff;
  color: #2d8cf0;
}
.switch-content div:hover {
  background: #fff;
  color: #2d8cf0;
}
</style>
